/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_aa4d6d14{display:block}\n"}]);
export const root = "root_aa4d6d14";